import { render, staticRenderFns } from "./DashboardJudicial.vue?vue&type=template&id=3d02e470&scoped=true"
import script from "./DashboardJudicial.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardJudicial.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DashboardJudicial.vue?vue&type=style&index=0&id=3d02e470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d02e470",
  null
  
)

export default component.exports